import { NextItemIcon } from '@icons'
import { Box, Text } from 'grommet'

type Props = {
  label: string
  active?: boolean
}

const Step = ({ label, active }: Props) => {
  return (
    <Box
      align="center"
      background={'#E1E1E1'}
      flex={false}
      height={'24px'}
      justify="center"
      round="full"
      style={{ position: 'relative' }}
      width={'24px'}
    >
      <Text color={'#000'} size="small" style={{ opacity: active ? 1 : 0.5 }}>
        {label}
      </Text>
    </Box>
  )
}

export default Step

type PatterProps = {
  title: string
  value: string
  handleClick?: () => void
  disabled?: boolean
}

export const PatternOption = ({ title, value, handleClick, disabled }: PatterProps) => {
  const onClick = () => {
    if (disabled) {
      return
    } else {
      handleClick && !disabled && handleClick()
    }
  }
  return (
    <Box direction="row" justify="between" style={{ opacity: disabled ? 0.5 : 1 }}>
      <Text size="xsmall" style={{ color: '#1A1A1A', textTransform: 'capitalize' }} weight={500}>
        {title}
      </Text>
      <Box align="center" direction="row" gap="6px" onClick={onClick}>
        <Text size="xsmall" style={{ color: '#1A1A1A', textTransform: 'capitalize' }} weight={500}>
          {value || 'Nill'}
        </Text>
        <NextItemIcon style={{ height: '12px' }} />
      </Box>
    </Box>
  )
}
